import { PrimaryColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      padding: [Spacings.s72, Spacings.s0],
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s56, Spacings.s0],
      },
    },
    title: {
      margin: 'auto',
      fontSize: FontSizes.s42,
      lineHeight: LineHeights.l50,
      maxWidth: 848,
      textAlign: 'center',
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s0, Spacings.s24],
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l28,
      },
    },
    description: {
      maxWidth: 764,
      textAlign: 'center',
      margin: 'auto',
      marginTop: Spacings.s8,
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l32,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s0, Spacings.s24],
        fontSize: FontSizes.s20,
        lineHeight: LineHeights.l32,
      },
    },
    gridContainer: {
      display: 'flex',
      margin: 'auto',
      marginTop: Spacings.s44,
      width: '100%',
      justifyContent: 'center',
    },
    gridItem: {
      margin: [0, Spacings.s16],
    },
    imageHolder: {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: CornerRadius.r8,
      width: 300,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        width: 312,
      },
      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        width: 270,
      },
    },
    content: {
      marginTop: Spacings.s16,
    },
    contentTitle: {
      display: 'block',
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l32,
      color: TextColors.base,
    },
    urlWrapper: {
      display: 'block',
      fontSize: FontSizes.s16,
      lineHeight: LineHeights.l28,
      '& a': {
        color: PrimaryColors.base.default,
      },
    },

    // skeleton

    titleFallback: {
      height: 48,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        height: 28,
      },
    },
    descriptionFallback: {
      height: 30,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        height: 20,
      },
    },
    descriptionWrapper: {
      marginTop: Spacings.s16,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        marginTop: Spacings.s8,
      },
    },

    gridItemFallback: {
      width: 300,
      height: 300,
    },
    contentTitleFallback: {
      marginTop: Spacings.s16,
      height: 30,
      width: 250,
    },
    contentBtnFallback: {
      marginTop: Spacings.s8,
      height: 30,
      width: 150,
    },
  }),
  {
    name: 'enterprise-girid',
  },
);

export default useStyles;
